export default __webpack_public_path__ + "static/media/download-bg.ea4250ce.jpg";